import * as THREE from 'three';

import { Gizmo, GizmoLineMaterial, GizmoMaterial, pickerMaterial } from './gizmo';

export class GizmoScale extends Gizmo {
  handleGizmos: any;
  pickerGizmos: any;

  constructor() {
    super();

    const arrowGeometry = new THREE.Mesh(new THREE.BoxGeometry(0.125, 0.125, 0.125));
    arrowGeometry.position.y = 0.5;
    arrowGeometry.updateMatrix();

    const lineXGeometry = new THREE.BufferGeometry();
    lineXGeometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0, 1, 0, 0], 3));

    const lineYGeometry = new THREE.BufferGeometry();
    lineYGeometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0, 0, 1, 0], 3));

    const lineZGeometry = new THREE.BufferGeometry();
    lineZGeometry.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0, 0, 0, 1], 3));

    this.handleGizmos = {
      X: [
        [
          new THREE.Mesh(arrowGeometry.geometry, new GizmoMaterial({ color: 0xff0000 })),
          [0.5, 0, 0],
          [0, 0, -Math.PI / 2],
        ],
        [new THREE.Line(lineXGeometry, new GizmoLineMaterial({ color: 0xff0000 }))],
      ],

      Y: [
        [
          new THREE.Mesh(arrowGeometry.geometry, new GizmoMaterial({ color: 0x00ff00 })),
          [0, 0.5, 0],
        ],
        [new THREE.Line(lineYGeometry, new GizmoLineMaterial({ color: 0x00ff00 }))],
      ],

      Z: [
        [
          new THREE.Mesh(arrowGeometry.geometry, new GizmoMaterial({ color: 0x0000ff })),
          [0, 0, 0.5],
          [Math.PI / 2, 0, 0],
        ],
        [new THREE.Line(lineZGeometry, new GizmoLineMaterial({ color: 0x0000ff }))],
      ],

      XYZ: [
        [
          new THREE.Mesh(
            new THREE.BoxGeometry(0.125, 0.125, 0.125),
            new GizmoMaterial({ color: 0xffffff, opacity: 0.25 }),
          ),
        ],
      ],
    };

    this.pickerGizmos = {
      X: [
        [
          new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0, 1, 4, 1, false), pickerMaterial),
          [0.6, 0, 0],
          [0, 0, -Math.PI / 2],
        ],
      ],

      Y: [
        [
          new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0, 1, 4, 1, false), pickerMaterial),
          [0, 0.6, 0],
        ],
      ],

      Z: [
        [
          new THREE.Mesh(new THREE.CylinderGeometry(0.2, 0, 1, 4, 1, false), pickerMaterial),
          [0, 0, 0.6],
          [Math.PI / 2, 0, 0],
        ],
      ],

      XYZ: [[new THREE.Mesh(new THREE.BoxGeometry(0.4, 0.4, 0.4), pickerMaterial)]],
    };

    this.init();
  }

  setActivePlane(axis: string, eye: THREE.Vector3) {
    eye.applyMatrix4(new THREE.Matrix4().extractRotation(this.planes!.XY!.matrixWorld).invert());

    if (axis === 'X') {
      this.activePlane = this.planes!.XY!;
      if (Math.abs(eye.y) > Math.abs(eye.z)) {
        this.activePlane = this.planes!.XZ!;
      }
    }

    if (axis === 'Y') {
      this.activePlane = this.planes!.XY!;
      if (Math.abs(eye.x) > Math.abs(eye.z)) {
        this.activePlane = this.planes!.YZ!;
      }
    }

    if (axis === 'Z') {
      this.activePlane = this.planes!.XZ!;
      if (Math.abs(eye.x) > Math.abs(eye.y)) {
        this.activePlane = this.planes!.YZ!;
      }
    }

    if (axis === 'XYZ') {
      this.activePlane = this.planes!.XYZE!;
    }
  }
}
